import script from "./ChordDiagramsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ChordDiagramsPanel.vue?vue&type=script&setup=true&lang=js"

import "./ChordDiagramsPanel.vue?vue&type=style&index=0&id=56fa16cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56fa16cf"]])

export default __exports__